import { AI_TOOL_TYPES } from './constants'

export const AI_TOOL_PRICING_TYPES = {
  PRODUCTION_ANALYZER_SHORT: 'productionAnalyzerShort',
  PRODUCTION_ANALYZER_ADVANCED: 'productionAnalyzerAdvanced',
  BUDGET_BREAKDOWN: 'budgetBreakdown',
  OPPORTUNITY_ENGINE: 'opportunityEngine',
}

export function getProductionAnalyzerPricingType(mode) {
  return mode === 'advanced'
    ? AI_TOOL_PRICING_TYPES.PRODUCTION_ANALYZER_ADVANCED
    : AI_TOOL_PRICING_TYPES.PRODUCTION_ANALYZER_SHORT
}

export function getPricingTypeForTool(toolType, { mode } = {}) {
  if (toolType === AI_TOOL_TYPES.PRODUCTION_ANALYZER) {
    return getProductionAnalyzerPricingType(mode || 'quick')
  }

  const map = {
    [AI_TOOL_TYPES.BUDGET_BREAKDOWN]: AI_TOOL_PRICING_TYPES.BUDGET_BREAKDOWN,
    [AI_TOOL_TYPES.OPPORTUNITY_ENGINE]:
      AI_TOOL_PRICING_TYPES.OPPORTUNITY_ENGINE,
  }

  return map[toolType] || null
}

export function resolvePricingDisplay({ pricingType, toolType, mode } = {}) {
  if (pricingType) {
    return { pricingType, pricePrefix: '' }
  }

  if (toolType === AI_TOOL_TYPES.PRODUCTION_ANALYZER) {
    if (mode) {
      return {
        pricingType: getProductionAnalyzerPricingType(mode),
        pricePrefix: '',
      }
    }

    return {
      pricingType: AI_TOOL_PRICING_TYPES.PRODUCTION_ANALYZER_SHORT,
      pricePrefix: '',
    }
  }

  return {
    pricingType: getPricingTypeForTool(toolType),
    pricePrefix: '',
  }
}
